import React from "react";
import { useNavigate } from "react-router-dom";
import "./Overview.css";
import Sidebar from "../Components/Sidebar";

function Overview() {
  const navigate = useNavigate();
  const lang = localStorage.getItem("lang") === "bn" ? "bn" : "en";

  const t = {
    en: {
      practice: "Practice",
      practiceDesc: "Practice with more than 900 driving questions.",
      mockTest: "Mock Test",
      mockDesc:
        "Mock test results are a good indicator of what to expect on the real test.",
      caseStudy: "Case Study",
      caseDesc:
        "Prepare for studying the cases of real life scenario questions.",
      hazard: "Hazard Perception",
      hazardDesc:
        "Choose from 36 Hazard Perception Tests to ready yourself for the actual test.",
      start: "Start Practice",
      flag: "Flagged Questions",
      flagDesc: "Review the questions you have flagged for later.",
    },
    bn: {
      practice: "অনুশীলন",
      practiceDesc: "৯০০+ ড্রাইভিং প্রশ্ন নিয়ে অনুশীলন করুন।",
      mockTest: "মক টেস্ট",
      mockDesc: "মূল পরীক্ষার মতো ফলাফল জানতে মক টেস্ট দিন।",
      caseStudy: "কেস স্টাডি",
      caseDesc:
        "বাস্তব জীবনের পরিস্থিতিভিত্তিক প্রশ্নগুলোর জন্য প্রস্তুতি নিন।",
      hazard: "হ্যাজার্ড পারসেপশন",
      hazardDesc:
        "মূল পরীক্ষার প্রস্তুতির জন্য ৩৬টি হ্যাজার্ড পারসেপশন টেস্ট বেছে নিন।",
      start: "অনুশীলন শুরু করুন",
      flag: "ফ্ল্যাগ করা প্রশ্নসমূহ",
      flagDesc: "পরে দেখার জন্য ফ্ল্যাগ করা প্রশ্নগুলো পর্যালোচনা করুন।",
    },
  }[lang];

  return (
    <div className={`overview ${lang === "bn" ? "bn-font" : ""}`}>
      <Sidebar />
      <div>
        <div className="overview-screen">
          <div className="overview-element">
            <div className="overview-title-container">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24px"
                viewBox="0 -960 960 960"
                width="24px"
                fill="#363350"
              >
                <path d="M200-200h57l391-391-57-57-391 391v57Zm-80 80v-170l528-527q12-11 26.5-17t30.5-6q16 0 31 6t26 18l55 56q12 11 17.5 26t5.5 30q0 16-5.5 30.5T817-647L290-120H120Zm640-584-56-56 56 56Zm-141 85-28-29 57 57-29-28Z" />
              </svg>
              <div className="overview-title">{t.practice}</div>
            </div>
            <div className="overview-details">{t.practiceDesc}</div>
            <div
              className="overview-button"
              onClick={() => navigate("/practice")}
            >
              {t.start}
            </div>
          </div>

          <div className="overview-element">
            <div className="overview-title-container">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24px"
                viewBox="0 -960 960 960"
                width="24px"
                fill="#363350"
              >
                <path d="m612-292 56-56-148-148v-184h-80v216l172 172ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-400Zm0 320q133 0 226.5-93.5T800-480q0-133-93.5-226.5T480-800q-133 0-226.5 93.5T160-480q0 133 93.5 226.5T480-160Z" />
              </svg>
              <div className="overview-title">{t.mockTest}</div>
            </div>
            <div className="overview-details">{t.mockDesc}</div>
            <div
              className="overview-button"
              onClick={() => navigate("/mocktest")}
            >
              {t.start}
            </div>
          </div>

          <div className="overview-element">
            <div className="overview-title-container">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24px"
                viewBox="0 -960 960 960"
                width="24px"
                fill="#363350"
              >
                <path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" />
              </svg>
              <div className="overview-title">{t.caseStudy}</div>
            </div>
            <div className="overview-details">{t.caseDesc}</div>
            <div
              className="overview-button"
              onClick={() => navigate("/casestudy")}
            >
              {t.start}
            </div>
          </div>

          <div className="overview-element">
            <div className="overview-title-container">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24px"
                viewBox="0 -960 960 960"
                width="24px"
                fill="#363350"
              >
                <path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h480q33 0 56.5 23.5T720-720v180l160-160v440L720-420v180q0 33-23.5 56.5T640-160H160Zm0-80h480v-480H160v480Zm0 0v-480 480Z" />
              </svg>
              <div className="overview-title">{t.hazard}</div>
            </div>
            <div className="overview-details">{t.hazardDesc}</div>
            <div
              className="overview-button"
              onClick={() => navigate("/hazard-list")}
            >
              {t.start}
            </div>
          </div>
          {/* <div className="overview-element">
            <div className="overview-title-container">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24px"
                viewBox="0 -960 960 960"
                width="24px"
                fill="#363350"
              >
                <path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h480q33 0 56.5 23.5T720-720v180l160-160v440L720-420v180q0 33-23.5 56.5T640-160H160Zm0-80h480v-480H160v480Zm0 0v-480 480Z" />
              </svg>
              <div className="overview-title">{t.flag}</div>
            </div>
            <div className="overview-details">{t.flagDesc}</div>
            <div
              className="overview-button"
              onClick={() => navigate("/hazard-list")}
            >
              {t.start}
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default Overview;
